<template>
    <div class="tag-select-wrap">
        <div class="tag-select-input" :class="{ 'tag-select-ative': isShowOption }" @click.stop="clickHandler">
            <ul class="tag-list-panle" v-if="selectedTag.length > 0">
                <li class="tag-list-item" v-for="(item, index) in selectedTag" :key="item.id">
                    <span>{{ item.label }}</span>
                    <Icon
                        class="tag-item-delete"
                        @iconClick="deleteClick(arguments, item, index)"
                        bgPosition="-4px -1px"
                        hoverBgPosition="-252px -20px"
                    ></Icon>
                </li>
            </ul>
            <span class="tag-placeholder" v-else>{{ placeholder }}</span>
        </div>
        <div class="tag-select-options" v-show="isShowOption">
            <Search class="tag-select-search" @inputChange="searchHandler" @searchChange="searchHandler"></Search>
            <MultiplePopupMenu height="300" :selected="selectedTag" :options="optionData" @menuClick="selectClick"></MultiplePopupMenu>
        </div>
    </div>
</template>

<script>
import Icon from "@/views/zhiji/bComponents/icons/Icon";
import Search from "@/views/zhiji/bComponents/inputs/Search";
import MultiplePopupMenu from "@/views/zhiji/bComponents/popupMenu/MultiplePopupMenu";
import { debounce, strTrim } from "@/views/zhiji/js/common/util.js";

export default {
    name: "TagSelect",
    props: ["selected", "disable", "placeholder", "type"],
    components: {
        Icon,
        Search,
        MultiplePopupMenu
    },
    data() {
        return {
            isShowOption: false,
            selectedTag: [],
            tagSearch: ""
        };
    },
    computed: {
        optionData() {
            let newData = this.getTagOptions;
            if (this.tagSearch != "") {
                return newData.filter(item => {
                    return item.label.indexOf(this.tagSearch) != -1;
                });
            } else {
                return newData;
            }
        },
        getTagOptions() {
            let option = this.getStorePorp("treeData");
            return this.flatData(option.children, "", []);
        }
    },
    mounted() {
        this.$store.dispatch("zhiji/queryTagTreesList", { type: this.type });
        this.selectedTag = this.getSelectedTag();
        this.searchTagChange = debounce(data => {
            this.tagSearch = strTrim(data[0].value);
        }, 500);
        window.document.addEventListener("click", this.windowClick);
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.materialLibraryPage[propName];
        },
        flatData(arr, label, newData) {
            arr &&
                arr.forEach(item => {
                    let str = label ? label + ">" + item.label : item.label;
                    newData.push({
                        label: str,
                        id: item.id
                    });
                    if (item.children.length != 0) {
                        this.flatData(item.children, str, newData);
                    }
                });
            return newData;
        },
        getSelectedTag() {
            let newData = this.getTagOptions;
            if (this.selected) {
                let idArr = this.selected.split(",");
                return newData.filter(item => {
                    return idArr.some(cId => {
                        return cId == item.id;
                    });
                });
            }
            return [];
        },
        getSelectState(data) {
            return this.selectedTag.some(item => item.id === data.id);
        },
        clickHandler() {
            !this.disable && (this.isShowOption = !this.isShowOption);
        },
        deleteClick(arg, data, index) {
            arg[0].stopPropagation();
            !this.disable && this.selectedTag.splice(index, 1);
            this.$emit("clickSelect", this.selectedTagToStr());
            this.$emit("deleteTag", data);
        },
        selectClick(data) {
            !this.getSelectState(data) && this.selectedTag.push(data);
            this.$emit("clickSelect", this.selectedTagToStr());
        },
        searchHandler(data) {
            this.searchTagChange(data);
            this.$emit("searchTag", data);
        },
        selectedTagToStr() {
            let selectedArr = [];
            this.selectedTag.forEach(item => {
                selectedArr.push(item.id);
            });
            return selectedArr.join(",");
        },
        windowClick(event) {
            if (this.isShowOption && this.zhiji.isClickOuter(event, "tag-select-wrap")) {
                this.isShowOption = false;
            }
        }
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    }
};
</script>

<style scoped lang="less">
.tag-select-wrap {
    position: relative;
    .tag-select-input {
        position: relative;
        min-height: 32px;
        font-size: 12px;
        box-sizing: border-box;
        padding: 0 2px;
        border: solid 1px #d8e4f0;
        border-radius: 4px;
        background: #fff;
        cursor: pointer;
        .tag-placeholder {
            display: inline-block;
            height: 30px;
            line-height: 30px;
            color: #9e9e9e;
            margin-left: 6px;
        }
        .tag-list-panle {
            list-style: none;
            display: flex;
            flex-wrap: wrap;

            .tag-list-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 4px 6px;
                background: #e4f1f9;
                border-radius: 3px;
                margin: 2px;

                .tag-item-delete {
                    margin-left: 7px;
                }
            }
        }
    }
    .tag-select-ative {
        border-color: #2088f3;
    }

    .tag-select-options {
        position: absolute;
        width: 100%;
        background-color: #fff;
        border-radius: 5px;
        margin: 5px 0;
        box-sizing: border-box;
        z-index: 100;
        .tag-select-search {
            width: 100%;
            padding: 7px 0;
        }
        .select-options-panel {
            width: 100%;
            position: relative;
        }
    }
}
</style>
